import { render } from "./index.vue?vue&type=template&id=f7865fac"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/atoms/avatar/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f7865fac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f7865fac', __exports__)) {
    api.reload('f7865fac', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f7865fac", () => {
    api.rerender('f7865fac', render)
  })

}


export default __exports__